import type { HelpFile } from '../../types/help'
import { DetectionHistoryCardTestIds } from '../../../testids/DetectionHistoryCardTestIds'

export const detectionHistoryCardHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [DetectionHistoryCardTestIds.detectionHistoryCard]:
      'Recent violation-detection runs for this rule — status, identities evaluated, and violations found or resolved per run.',
    [DetectionHistoryCardTestIds.cardTitleDetectionHistory]: null,
    [DetectionHistoryCardTestIds.detectionLoading]: null,
    [DetectionHistoryCardTestIds.detectionEmpty]: null,
    [DetectionHistoryCardTestIds.detectionError]: null,
    [DetectionHistoryCardTestIds.linkViewAllDetections]:
      'Open the full detection history including older runs and per-violation details.',
  },
}
